import { render, staticRenderFns } from "./Brightcove.vue?vue&type=template&id=75d8d491&scoped=true&"
import script from "./Brightcove.vue?vue&type=script&lang=js&"
export * from "./Brightcove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d8d491",
  null
  
)

export default component.exports